import { createProviderToken } from '@core/common-legacy';
import { ReportsComponentValueDecorator } from '@core/reports-types';

// Required only because of default group difference between kiwi/rec
// TODO remove after #86c5d6zvc
const { provide: provideDecorator, inject: injectBuilderComponentDecorator } =
  createProviderToken<ReportsComponentValueDecorator>('ReportsBuilderComponentValueDecorator')();

export const provideBuilderComponentValueDecoratorFn = (
  decoratorFn: ReportsComponentValueDecorator,
) =>
  provideDecorator({
    useValue: decoratorFn,
  });

export { injectBuilderComponentDecorator };
